import React, { useState } from 'react'
import { Box, Tabs, Tab, styled } from '@mui/material'
import { Article as ArticleIcon, Info as InfoIcon } from '@mui/icons-material'
import { GuidanceSupportData } from '@/apps/legacy/features/guidance/types/guidanceTypes'
import GuidanceScriptTab from '../GuidanceScriptTab'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'
import GuidanceDetailTab from '../GuidanceDetailTab'

// カスタムスタイル付きTabsコンポーネント（色を使わないデザイン）
const BlackTabs = styled(Tabs)(() => ({
  '& .MuiTabs-indicator': {
    backgroundColor: colorTokens.special.pureBlack,
    height: 2,
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    minHeight: 48,
    color: colorTokens.special.pureBlack,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&.Mui-selected': {
      color: colorTokens.special.pureBlack,
      backgroundColor: 'transparent',
    },
  },
}))

type Props = {
  guidanceData: GuidanceSupportData
  onSaveScripts?: (
    scriptSelections: Record<string, boolean>,
    scriptOrder: string[]
  ) => Promise<void>
  onCancel?: () => void
}

const TAB_INDICES = {
  PHRASE: 0,
  DETAIL: 1,
}

const GuidanceSupport: React.FC<Props> = ({
  guidanceData,
  onSaveScripts,
  onCancel,
}) => {
  const [selectedTab, setSelectedTab] = useState(TAB_INDICES.PHRASE)

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: colorTokens.border.light,
          backgroundColor: colorTokens.background.subtle,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <BlackTabs
          value={selectedTab}
          onChange={handleTabChange}
          sx={{
            '& .MuiTab-root': {
              px: 3,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              marginRight: 0.5,
              transition: 'all 0.2s ease',
            },
          }}
        >
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ArticleIcon />
                フレーズ
              </Box>
            }
          />
          <Tab
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <InfoIcon />
                詳細
              </Box>
            }
          />
        </BlackTabs>
      </Box>
      <Box
        sx={{
          animation: 'fadeIn 0.3s ease-in-out',
          '@keyframes fadeIn': {
            from: { opacity: 0, transform: 'translateY(10px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <Box
          sx={[
            selectedTab === TAB_INDICES.PHRASE
              ? {
                  display: 'block',
                }
              : {
                  display: 'none',
                },
          ]}
        >
          <GuidanceScriptTab
            scriptData={guidanceData.scriptData}
            onSave={onSaveScripts}
            onCancel={onCancel}
          />
        </Box>
        <Box
          sx={[
            selectedTab === TAB_INDICES.DETAIL
              ? {
                  display: 'block',
                }
              : {
                  display: 'none',
                },
          ]}
        >
          <GuidanceDetailTab detailData={guidanceData.detailData} />
        </Box>
      </Box>
    </Box>
  )
}

export default GuidanceSupport
